export default {
    // ユーザープロファイル ****************************************************
    // ユーザー名
    nameRules: [
        v => !!v || "名前は必須項目です",
        v => v.length <= 10 || "名前は10文字以内で入力してください",
        v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // メールアドレス
    emailRules: [
        v => !!v || "メールアドレスは必須項目です",
        v => /.+@.+/.test(v) || "メールアドレスの形式で入力してください",
        v => v.length <= 50 || "メールアドレスは50文字以内で入力してください",
        v => /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/.test(v) || "半角英数字と記号のみで入力してください",
        v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // パスワード
    passwordRules: [
        v => !!v || "パスワードは必須項目です",
        v => v.length >= 9 || "パスワードは9文字以上で入力してください",
        v => v.length <= 16 || "パスワードは16文字以内で入力してください",
        v => /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(v) || "半角英数字と記号のみで入力してください",
        v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 部署名
    departmentNameRules: [
        v => !!v || "部署名は必須項目です。",
        v => v.length <= 100 || "部署名は100文字以内で入力してください。",
        v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 課名
    sectionNameRules: [
      v => v.length <= 100 || "課名は100文字以内で入力してください。"
    ],
    // 工番:固定部
    constructionNumberFixedRules: [
      v => !!v || "工番:固定部は必須項目です",
      v => v.length <= 10 || "工番:固定部は10文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工番:連番部
    constructionNumberSerialRules: [
      v => !!v || "工番:連番部は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,6})$/.test(v) || "工番:連番部は6桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 工番:連番部桁数
    constructionNumberDigitRules: [
      v => !!v || "工番:連番部桁数は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-6]{1,1})$/.test(v) || "工番:連番部は1から6以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 取引先マスタ
    // 取引先名
    suppliersNameRules: [
      v => !!v || "取引先名は必須項目です",
      v => v.length <= 100 || "取引先名は100文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工事マスタ
    // 担当部署
    departmentRules: [
      v => !!v || "担当部署は必須項目です",
    ],
    // 工番
    constructionNumberRules: [
      v => !!v || "工番は必須項目です",
      v => v.length <= 15 || "工番名は15文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工事名
    constructionNameRules: [
      v => !!v || "工事名は必須項目です",
      v => v.length <= 100 || "工事名は100文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工事場所
    placeRules: [
      v => !!v || "工事場所は必須項目です",
      v => v.length <= 100 || "工事場所は100文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工期
    constructionDateRules: [
      v => !!v || "工期は必須項目です",
    ],
    // 監督者
    managementUserNameRules: [
      v => !!v || "監督者は必須項目です",
    ],
    // 発注者
    orderNameRules: [
      v => v.length <= 100 || "発注者は100文字以内で入力してください"
    ],
    // 施工者
    builderNameRules: [
      v => v.length <= 100 || "施工者は100文字以内で入力してください"
    ],
    // 機材種別
    equipmentTypeRules: [
      v => !!v || "機材種別は必須項目です",
    ],
    // 機材名称
    equipmentNameRules: [
      v => !!v || "機材名称は必須項目です",
      v => v.length <= 100 || "機材名称は100文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 自社区分
    inHouseClassRules: [
      v => !!v || "自社区分は必須項目です",
    ],
    // 取引先
    suppliersRules: [
      v => !!v || "取引先は必須項目です",
    ],
    // 歩掛
    percentageRules: [
      v => !!v || "歩掛は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9})(\.[0-9]{1,5})?$/.test(v) || "歩掛は整数値9桁小数点以下第5位以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 数量×歩掛
    multiplRules: [
      v => !!v || "数量×歩掛は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{1,1})?$/.test(v) || "数量×歩掛は整数値9桁小数点以下第1位以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 単価
    unitPriceRules: [
      v => !!v || "単価は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{0,0})?$/.test(v) || "単価は整数値9桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 使用予定期間
    useDateRules: [
      v => !!v || "使用予定期間は必須項目です",
    ],
    // 外注作業者氏名
    subcontractorNameRules: [
      v => !!v || "氏名は必須項目です",
      v => v.length <= 100 || "氏名は100文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 工種名称
    budgetNameRules: [
      v => !!v || "工種名称は必須項目です",
      v => v.length <= 15 || "工種名称は15文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 費目名称
    expenseNameRules: [
      v => !!v || "費目名称は必須項目です",
      v => v.length <= 50 || "費目名称は50文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 単位
    displayUnitRules: [
      v => !!v || "単位は必須項目です",
      v => v.length <= 5 || "単位は5文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 勘定科目
    accountRules: [
      v => !!v || "勘定科目は必須項目です",
    ],
    // 企業名称
    clientNameRules: [
      v => !!v || "企業名称は必須項目です",
      v => v.length <= 50 || "企業名称は50文字以内で入力してください",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // テーマ配色
    themeRules: [
      v => !!v || "テーマ配色は必須項目です",
    ],
    // 数量
    amountRules: [
      v => !!v || "数量は必須項目です",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{1,2})?$/.test(v) || "数量は整数値9桁小数点以下第2位以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 規格等
    standardNameRules: [
      v => v.length <= 50 || "規格等は50文字以内で入力してください"
    ],
    // 備考
    remarksRules: [
      v => v.length <= 100 || "備考は100文字以内で入力してください"
    ],
    // テンプレート名
    templateNameRules: [
      v => !!v || "テンプレート名は必須項目です",
      v => v.length <= 50 || "テンプレート名は50文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 受注金額
    acceptPriceRules: [
      v => v >= 0 || "0以上の数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{0,0})?$/.test(v) || "受注金額は9桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 集計費目名
    aggregateNameRules: [
      v => !!v || "集計費目名は必須項目です。",
      v => v.length <= 10 || "集計費目名は10文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    aggregateSelectRules: [
      v => !!v || "集計費目名は必須項目です。",
    ],
    // 工番タグ作成
    constructionNumberTagRules: [
      v => !!v || "工番は必須項目です。",
    ],
    // 工種
    constructionTypeRules: [
      v => !!v || "工種は必須項目です。",
    ],
    // 作業項目
    workItemRules: [
      v => !!v || "作業項目は必須項目です。",
    ],
    // 休憩時間
    breakHourTimeRules: [
      v => v >= 0 || "0以上の数値を入力してください",
      v => v < 24 || "24より小さい数値を入力してください",
    ],
    // 休憩分
    breakMinuteTimeRules: [
      v => v >= 0 || "0以上の数値を入力してください",
      v => v < 60 || "60より小さい数値を入力してください",
    ],
    // 作業開始時間
    workerTimeStartRules: [
      v => !!v || "作業開始時間は必須項目です。"
    ],
    // 作業終了時間
    workerTimeEndRules: [
      v => !!v || "作業終了時間は必須項目です。"
    ],
    // 作業内容
    workerContentRules: [
      v => !!v || "作業内容は必須項目です。",
      v => v.length <= 1000 || "作業内容は1000文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 権限名称
    permissionNameRules: [
      v => !!v || "権限名称は必須項目です。",
      v => v.length <= 20 || "権限名称は20文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 権限
    permissionRules: [
      v => !!v || "権限名称は必須項目です。",
    ],
    // カテゴリ
    categoryRules: [
      v => !!v || "カテゴリは必須項目です",
    ],
    // カテゴリ名
    categoryNameRules: [
      v => !!v || "カテゴリ名は必須項目です。",
      v => v.length <= 20 || "カテゴリ名は20文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // テンプレート
    templateRules: [
      v => !!v || "テンプレートは必須項目です。"
    ],
    // 等級
    rankRules: [
      v => !!v || "等級は必須項目です",
    ],
    // 等級名
    rankNameRules: [
      v => !!v || "等級名は必須項目です。",
      v => v.length <= 20 || "等級名は20文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // 順番号
    sequenceNumberRules: [
      v => !!v || "順番号は必須項目です。",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,3}|0)(\.[0-9]{0,0})?$/.test(v) || "順番号は3桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 日給
    dailyPayRules: [
      v => !!v || "日給は必須項目です。",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{0,0})?$/.test(v) || "日給は9桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 時給
    hourlyPayRules: [
      v => !!v || "時給は必須項目です。",
      v => v > 0 || "0より大きい数値を入力してください",
      v => /^([0-9]{1,9}|0)(\.[0-9]{0,0})?$/.test(v) || "時給は9桁以内で入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
    ],
    // 処理年月(作業日報確認用)
    processDateRules: [
      v => !!v || "処理年月は必須項目です。"
    ],
    // 休憩時間（デフォルト値）
    defaultBreakHourTimeRules: [
      v => v.length !== 0 || "休憩(時間)は必須項目です。",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
      v => v >= 0 || "0以上の数値を入力してください",
      v => v < 24 || "24より小さい数値を入力してください",
    ],
    // 休憩分（デフォルト値）
    defaultBreakMinuteTimeRules: [
      v => v.length !== 0 || " 休憩(分)は必須項目です。",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください",
      v => v >= 0 || "0以上の数値を入力してください",
      v => v < 60 || "60より小さい数値を入力してください",
    ],
    // お知らせ内容
    notificationContentRules: [
      v => !!v || "お知らせ内容は必須項目です。",
      v => v.length <= 1500 || "お知らせ内容は1500文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // タイトル
    notificationTitleRules: [
      v => !!v || "タイトルは必須項目です。",
      v => v.length <= 20 || "タイトルは20文字以内で入力してください。",
      v => (v.trim().length > 0) || '空白のみの入力はできません'
    ],
    // ヘルプ機能（お問い合わせ）****************************************************
    // 名前
    inquiryNameRules: [
      v => !!v || "お名前は必須項目です。",
      v => v.length <= 20 || "お名前は20文字以内で入力してください。",
      v => (v.trim().length > 0) || "空白のみの入力はできません。"
    ],
    // メールアドレス
    inquiryMailRules: [
      v => !!v || "メールアドレスは必須項目です。",
      v => /.+@.+/.test(v) || "メールアドレスの形式で入力してください",
      v => v.length <= 254 || "メールアドレスは254文字以内で入力してください。",
      v => /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/.test(v) || "半角英数字と記号のみで入力してください",
      v => /^[\S+]*$/.test(v) || "空白を含めずに入力してください"
    ],
    // お問い合わせ件名
    inquiryTitleRules: [
      v => !!v || "お問い合わせ件名は必須項目です。",
      v => v.length <= 40 || "お問い合わせ件名は40文字以内で入力してください。",
      v => (v.trim().length > 0) || "空白のみの入力はできません。"
    ],
    // お問い合わせ内容
    inquiryContentRules: [
      v => !!v || "お問い合わせ内容は必須項目です。",
      v => v.length <= 1000 || "お問い合わせ内容は1000文字以内で入力してください。",
      v => (v.trim().length > 0) || "空白のみの入力はできません。"
    ],
    // *************************************************************************
};
